// extracted by mini-css-extract-plugin
export var body = "CustomPromoErrorModal-module--body--4863a";
export var buttonsContainer = "CustomPromoErrorModal-module--buttons-container--156ac";
export var contacts = "CustomPromoErrorModal-module--contacts--ab31d";
export var errorIconContainer = "CustomPromoErrorModal-module--error-icon-container--41755";
export var modalBodyWrapper = "CustomPromoErrorModal-module--modal-body-wrapper--90a00";
export var modalContent = "CustomPromoErrorModal-module--modal-content--223ac";
export var openings = "CustomPromoErrorModal-module--openings--2632a";
export var phoneNumber = "CustomPromoErrorModal-module--phone-number--050cd";
export var title = "CustomPromoErrorModal-module--title--0d606";